import { PartnerProgramConfigPayload } from '@/@types/PartnerProgram';
import { toast } from '@/hooks/use-toast';
import { PartnerProgramService } from '@/services/partner-program.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export function useConfigurePartnerProgram(productId: string) {
  const { t } = useTranslation(['affiliates', 'common']);
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (data: PartnerProgramConfigPayload) =>
      PartnerProgramService.savePartnerProgram(productId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['partner-program', productId],
      });
      toast({
        variant: 'success',
        description: t('affiliates:partner_program_saved'),
      });
    },
    onError: () => {
      toast({
        variant: 'error',
        description: t('common:data_submission_error'),
      });
    },
  });

  return {
    configurePartnerProgram: mutateAsync,
    isConfiguring: isPending,
  };
}
